import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchTeamLeadByOperator = async (operatorId: string) => {
  const response = await queryExecute({
    query: graphql(`
      query TeamLeadByOperator($operatorId: String!) {
        teamLeadByOperator(operatorId: $operatorId) {
          id
          firstName
          lastName
          slackId
        }
      }
    `),
    variables: {
      operatorId,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.teamLeadByOperator;
};
